import React from 'react';
import { Link } from 'react-router-dom';
import styles from './ProjectSecretaryBrand.module.scss';

type ProjectSecretaryBrandProps = {
  className?: string;
};

const ProjectSecretaryBrand: React.FC<ProjectSecretaryBrandProps> = ({ className }) => (
  <Link
    className={`${styles.brand} ${className ?? ''}`.trim()}
    to="/"
    aria-label="Project Secretary homepage"
  >
    <span className={styles.mark}>PS</span>
    <span className={styles.text}>
      <strong>Project Secretary</strong>
      <small>Intelligent Call Handling at Scale</small>
    </span>
  </Link>
);

export default ProjectSecretaryBrand;
